<template>
  <div style="height: 100%">   
    <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>
    
    <div>
        <vx-card>
            <div class="vx-row mb-4">
                <div class="vx-col md:w-1/2 w-full">                    
                    <vs-button class="ml-auto mt-2" size="small" @click="gravar" color="success" v-if="temPermissaoAlterar">Gravar</vs-button>
                    <vs-button class="ml-4 mt-2" size="small" @click="excluir" v-show="isDeletable && temPermissaoAlterar" color="danger">Excluir</vs-button>            
                    <vs-button class="ml-4 mt-2" size="small" type="border" color="dark" @click="voltar">Voltar</vs-button>             
                </div>
            </div>                       
            <div class="vx-row">        
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Banco</label>
                    <v-select                                                                         
                        :options="CONSTANTES_BANCO"  
                        :reduce="r => r.data"  
                        v-model="data_local.numero"                             
                    class="v-select w-full"></v-select> 
                </div>      

                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Nome</label>
                    <vs-input class="w-full" v-model="data_local.nome" :maxlength="45"/>   
                </div>                 
            </div>
            <div class="vx-row"> 
                <div class="vx-col w-full">
                    <label class="vs-input--label">Titular</label>
                    <vs-input class="w-full" v-model="data_local.titular" :maxlength="255"/>   
                </div>                 
            </div>            
            <div class="vx-row">        
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Agencia</label>
                    <div class="flex">
                        <vs-input class="w-full" v-model="data_local.agencia" :maxlength="45"/>   
                        <vs-input class="ml-2" v-model="data_local.digitoAgencia" :maxlength="1" v-if="isBancoComAgenciaDigito"/>   
                    </div>
                </div>                                  
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Conta</label>
                    <div class="flex">
                        <vs-input class="w-full" v-model="data_local.conta" :maxlength="45"/>   
                        <vs-input class="ml-2" v-model="data_local.digitoConta" :maxlength="1"/>   
                    </div>
                </div>                 
            </div>  

            <div class="vx-row">                
                <div class="vx-col w-1/3">
                    <label class="vs-input--label">Status</label>                    
                    <v-select                                               
                        :options="CONTANTES_STATUS_INSTITUICAO" 
                        v-model="data_local.status"    
                        :clearable="false"
                        :reduce="r => r.data"                                                                                              
                        class="v-select w-full">
                    </v-select>  
                </div>                                 
                <div class="vx-col w-1/3" v-if="isBancoComCarteiraCobranca">
                    <label class="vs-input--label">Carteira Emissão Boleto</label>
                    <vs-input class="w-full" v-model="data_local.carteiraEmissaoBoleto" :maxlength="45"/>
                </div>                 
                <div class="vx-col w-1/3" v-if="isBancoComConvenio">
                    <label class="vs-input--label">Convênio Emissão Boleto</label>
                    <div class="flex">
                        <vs-input class="w-full" v-model="data_local.convenioEmissaoBoleto" :maxlength="45"/>
                        <vs-input class="ml-2" v-model="data_local.convenioEmissaoBoletoDigito" :maxlength="1" v-if="isBancoComConvenioDigito"/>
                    </div>
                </div>                 
            </div>  

            <div class="vx-row">            
                <div class="vx-col w-1/5">
                    <label class="vs-input--label">Utiliza  Remessa ?</label>
                    <vs-checkbox class="w-full mt-2" v-model="data_local.utilizaRemessa"> </vs-checkbox>
                </div>                              
                <div class="vx-col w-1/5" v-if="data_local.utilizaRemessa">
                    <label class="vs-input--label">Sequencial da Remessa</label>
                    <vue-autonumeric class="vs-inputx vs-input--input normal hasValue" v-model="data_local.sequencialRemessa" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'0' }]"></vue-autonumeric>                 
                </div>                 
                <div class="vx-col w-1/5">
                    <label class="vs-input--label">Multa Percentual</label>
                    <vue-autonumeric class="vs-inputx vs-input--input normal hasValue" v-model="data_local.multaPercentual" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>                 
                </div>                 
                <div class="vx-col w-1/5">
                    <label class="vs-input--label">Juros Percentual</label>
                    <vue-autonumeric class="vs-inputx vs-input--input normal hasValue" v-model="data_local.jurosPercentual" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>                 
                </div>                 
                <div class="vx-col w-1/5" v-if="isBancoComCodigoEmpresa">
                    <label class="vs-input--label">Código Empresa</label>
                    <vs-input class="vs-inputx w-full" v-model="data_local.codigoEmpresa" :maxlength="45"/>                 
                </div>                 
            </div>                          
        </vx-card>  
    </div>
    
  </div>
</template>

<script>
import axios from "@/axios.js"
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue';
const URL_SERVLET = "/Instituicao";
const NAME_ROUTE_SEARCH = "cadastro-instituicoes-pesquisar";
import { CONSTANTES_BANCO } from '@/constantesComboBox.js'
import { CONTANTES_STATUS_INSTITUICAO } from '@/constantesComboBox.js'


export default { 
  components: {  
    VueAutonumeric
  },      
  props: {
    registroOriginal: {
      type: Object,
      required: false,
      default: function () {
        return { tipo: null, nome: null, numero: null, agencia: null, digitoAgencia: null, conta: null, digitoConta: null,  titular: null, 
            saldoIncial: null, dataSaldoInicial: null, status: 'ATIVO', convenioEmissaoBoleto: null, carteiraEmissaoBoleto: null, convenioEmissaoBoletoDigito: null,
            utilizaRemessa: true,  sequencialRemessa: 0, multaPercentual: null,  jurosPercentual: null, codigoEmpresa: null
         }
       }
    },
  },
  data() {
    return {        
        errorsValidacao: [],  
        listaCategorias: [],
        data_local: JSON.parse(JSON.stringify(this.registroOriginal))        
    }
  },  
  created(){
    this.CONSTANTES_BANCO = CONSTANTES_BANCO;    
    this.CONTANTES_STATUS_INSTITUICAO = CONTANTES_STATUS_INSTITUICAO;
  }, 
  mounted() {
    this.fetchCategorias();
    if (this.registroOriginal.hasOwnProperty('id')) {
        this.$vs.loading()
        this.findById();  
    } 
  },
  computed: {      
    isDesabilitarCampo(){
        return this.data_local != null && this.data_local.hasOwnProperty("id");
    }, 
    isDeletable() {
       return this.data_local != null && this.data_local.hasOwnProperty("id");
    }, 
    isGestor() {
      return (this.$store.state.AppActiveUser.perfil === 'GESTOR' || this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA');
    },
    temPermissaoAlterar() {
        if ( this.isGestor ) {
            return true;
        } 

        if (this.data_local !== null && this.data_local.hasOwnProperty("id")) {
            if (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') {
                return true;
            }

            return false;
        } else {
            if (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') {
                return true;
            }

            return false;
        }        
    },
    isBancoComConvenioDigito() {
        if (this.data_local.numero === "104") {           
            return true;
        } else if (this.data_local.numero  == "001") {            
            return false;
        }  else if (this.data_local.numero  == "341") {            
            return false;
        } else if (this.data_local.numero  == "237") {            
            return false;
        } else if (this.data_local.numero  == "756") {		            
            return true;
        } else if (this.data_local.numero  == "353") {		            
            return true;
        }   
        
        return false;
    },
    isBancoComAgenciaDigito() {
        if (this.data_local.numero === "104") {           
            return false;
        } else if (this.data_local.numero  == "001") {            
            return true;
        }  else if (this.data_local.numero  == "341") {            
            return false;
        } else if (this.data_local.numero  == "237") {            
            return false;
        } else if (this.data_local.numero  == "756") {		            
            return true;
        } else if (this.data_local.numero  == "353") {		            
            return false;
        }  
        
        return false;
    },
    isBancoComConvenio() {
        if (this.data_local.numero === "104") {           
            return true;
        } else if (this.data_local.numero  == "001") {            
            return true;
        }  else if (this.data_local.numero  == "341") {            
            return false;
        } else if (this.data_local.numero  == "237") {            
            return false;
        } else if (this.data_local.numero  == "756") {		            
            return true;
        } else if (this.data_local.numero  == "353") {		            
            return true;
        }  
        
        return false;
    },
    isBancoComCodigoEmpresa() {
        if (this.data_local.numero === "104") {           
            return true;
        } else if (this.data_local.numero  == "001") {            
            return true;
        }  else if (this.data_local.numero  == "341") {            
            return false;
        } else if (this.data_local.numero  == "237") {            
            return false;
        } else if (this.data_local.numero  == "756") {		            
            return true;
        } else if (this.data_local.numero  == "353") {		            
            return true;
        } else if (this.data_local.numero  == "403") {		            
            return true;
        }    
        
        return false;
    },
    isBancoComCarteiraCobranca() {
        if (this.data_local.numero  == "403") {		            
            return false;
        }    
        
        return true;
    }
  },
  methods: {  
    fetchCategorias() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      
      axios.post("/CategoriaProduto/ListarCategoriaProduto", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
            this.listaCategorias = response.data.Resultado.lista;              
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    }, 
    findById() {       
        const params = new URLSearchParams();       
        params.append('id', this.data_local.id);           
                
        axios.post(URL_SERVLET + "/recuperar", params, {              
            headers: {'Accept': 'application/json' }, credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close()            
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                 this.data_local = response.data.Instituicao;                            
                 this.data_local.numero = String(this.data_local.numero);
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    }, 
    excluir() {
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja excluir ?', acceptText: 'Sim', cancelText: 'Não', accept: this.excluirRequest
        });
    },
    excluirRequest() {
        this.$vs.loading();  
        const params = new URLSearchParams();                        
        params.append('listaIds', this.data_local.id);   
                
        axios.post(URL_SERVLET + "/remover", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("error")) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.error, acceptText: 'OK'})
                } else {
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    },
    gravar() {        
        if (this.formularioValido()) { 
            this.$vs.loading();
            const params = new URLSearchParams();    
            
            if (this.data_local.hasOwnProperty('id')) {
                params.append('id', this.data_local.id);    
            }

            params.append('tipo', "Conta Bancaria");            
            params.append('nome', this.data_local.nome);            
            params.append('numero', this.data_local.numero);   
            params.append('agencia', this.data_local.agencia);  
            if (this.isBancoComAgenciaDigito)  {
                params.append('digitoAgencia', this.data_local.digitoAgencia);  
            }
            params.append('conta', this.data_local.conta);  
            params.append('digitoConta', this.data_local.digitoConta);  
            params.append('titular', this.data_local.titular); 
            
            if (this.isBancoComConvenio)  {
                params.append('convenioEmissaoBoleto', this.data_local.convenioEmissaoBoleto);  
                if (this.isBancoComConvenioDigito)  {
                    params.append('convenioEmissaoBoletoDigito', this.data_local.convenioEmissaoBoletoDigito);  
                }
            }

            params.append('carteiraEmissaoBoleto', this.data_local.carteiraEmissaoBoleto);  
            params.append('saldoIncial', 0);
            params.append('dataSaldoInicial', "2024-01-01");
            
            params.append('utilizaRemessa', this.data_local.utilizaRemessa);
            params.append('status', this.data_local.status);
            if (this.data_local.utilizaRemessa) {
                params.append('sequencialRemessa', this.data_local.sequencialRemessa);
            }
            params.append('multaPercentual', this.data_local.multaPercentual);
            params.append('jurosPercentual', this.data_local.jurosPercentual);

            if (this.isBancoComCodigoEmpresa) {
                params.append('codigoEmpresa', this.data_local.codigoEmpresa);
            }
            

            axios.post(URL_SERVLET + "/gravar", params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                    
                    this.$vs.loading.close()
                    this.$router.push({ path: '/' });
                } else {                    
                    if (response.data.Instituicao.erroOperacao) {                 
                        this.$vs.loading.close()       
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.Instituicao.mensagemResultadoOperacao, acceptText: 'OK'})
                    } else {                        
                         this.$vs.notify({
                            title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                            text: response.data.Instituicao.mensagemResultadoOperacao,
                        });

                        this.data_local = response.data.Instituicao;  
                        this.findById();
                    }                   
                }
            })
            .catch((error) => { 
                this.$vs.loading.close();
                /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }         
    },
    voltar() {
        this.$router.push({
            name: NAME_ROUTE_SEARCH                     
        })
    },
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];
        
        if (!this.data_local.nome) { this.errorsValidacao.push("Nome obrigatório"); }
        if (!this.data_local.titular) { this.errorsValidacao.push("Titular obrigatório"); }
        if (!this.data_local.agencia) { this.errorsValidacao.push("Agência obrigatório"); }
        if (this.isBancoComAgenciaDigito && !this.data_local.digitoAgencia) { this.errorsValidacao.push("Digito da Agência obrigatório"); }
        if (!this.data_local.conta) { this.errorsValidacao.push("Conta obrigatório"); }
        if (!this.data_local.digitoConta) { this.errorsValidacao.push("Digito da Conta obrigatório"); }
        if (this.data_local.utilizaRemessa && !this.data_local.sequencialRemessa) { this.errorsValidacao.push("Sequencial de Remessa obrigatório"); }

        if (this.isBancoComConvenio && !this.data_local.convenioEmissaoBoleto) { this.errorsValidacao.push("Convênio obrigatório"); }
        console.log(this.data_local.convenioEmissaoBoletoDigito);
        if (this.isBancoComConvenio && this.isBancoComConvenioDigito && !this.data_local.convenioEmissaoBoletoDigito && String(this.data_local.convenioEmissaoBoletoDigito) !== '0') { this.errorsValidacao.push("Digito Convênio obrigatório"); }
              
        if (!this.errorsValidacao.length) {
            return true;
        }   
        return false;
    },    
  }
}
</script>

<style scoped>  
  .vs__dropdown-menu {
    max-height: 80px;    
  }
</style>

<style scoped>
  .tabelaComScroll {      
      overflow: auto;  
      height: calc(100vh - 300px);
      position: relative;      
    } 
</style>